// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { pickUpLocationAddressInfoDisplayStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/PickUpLocationAddressInfoDisplay";
import { GridOffset } from "@insite/mobius/GridContainer";
import { styledBoxStyle } from "@keller/App/Components/Common/StyledBox";
import { reviewSectionAddressesStyles } from "@keller/Overrides/Widgets/CheckoutShipping/SharedAddresses.style";
import { color, mergeWithCss, xScreen } from "@keller/XDL/Utilities";
import { css } from "styled-components";

pickUpLocationAddressInfoDisplayStyles.container = {
    ...mergeWithCss(reviewSectionAddressesStyles.container, {
        css: css`
            ${GridOffset} {
                @media print {
                    margin: 0;
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    flex-wrap: nowrap;
                    flex: 1;
                }
            }
            @media print {
                display: flex;
                flex-direction: column;
                max-width: 500px;
                height: 100%;
            }
        `,
    }),
};

pickUpLocationAddressInfoDisplayStyles.headingGridItem = {
    ...mergeWithCss(reviewSectionAddressesStyles.headingGridItem, {
        css: css`
            @media print {
                background-color: ${color("common.white")};
                border: 1px solid ${color("common.border")};
                border-bottom: 0;
                padding: 8px;
                margin: 0;
                display: flex;
                flex: 0;
            }
        `,
    }),
};

pickUpLocationAddressInfoDisplayStyles.headingText = {
    ...mergeWithCss(reviewSectionAddressesStyles.heading, {
        css: css`
            @media print {
                font-size: 12px;
                line-height: 18px;
            }
        `,
    }),
    forwardAs: "h2",
};

pickUpLocationAddressInfoDisplayStyles.addressGridItem = {
    width: 12,
    css: css`
        &&& {
            flex-direction: column;
            @media print {
                ${styledBoxStyle}
                padding: 8px;
                display: flex;
                flex-direction: column;
            }
        }
    `,
};

pickUpLocationAddressInfoDisplayStyles.address = {
    ...mergeWithCss(pickUpLocationAddressInfoDisplayStyles.address, {
        wrapper: {
            css: css`
                @media print {
                    display: flex;
                    flex-direction: column;
                    flex: 1;
                }
            `,
        },
    }),
    companyNameText: {
        ...reviewSectionAddressesStyles.address?.companyNameText,
    },
};

pickUpLocationAddressInfoDisplayStyles.locationNameText = {
    weight: 600,
};

pickUpLocationAddressInfoDisplayStyles.locationNameText = {
    ...reviewSectionAddressesStyles.address?.companyNameText,
};

pickUpLocationAddressInfoDisplayStyles.editLink = {
    ...reviewSectionAddressesStyles.editLink,
};
